/**
 * Created by WorkAxis www.workaxis.in
 * About page.
 */
import React from 'react';
import "./style.css";
import {ourTeam, values, testimony} from "./data";
import {useReveal, PageHero, CtaSection} from "./shared";

export default function About() {
    useReveal();

    return (
        <div>
            <PageHero
                kicker="About"
                title={<>The team behind <span className="wx-grad-text">WorkAxis.</span></>}
                lead="WorkAxis Private Limited is a bootstrapped AI and product engineering company with 5+ years
                      of experience — based in Chennai, India and serving clients worldwide. We build client
                      systems and operate our own SaaS, AntCRM."
            />

            {/* ---------- Story ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <div className="wx-story-grid">
                        <div className="wx-reveal">
                            <div className="wx-kicker">Why "WorkAxis"</div>
                            <h2 className="wx-h2">Built to move your business <span className="wx-grad-text">forward.</span></h2>
                        </div>
                        <div className="wx-story-text wx-reveal">
                            <p>
                                WorkAxis is the engineering, automation and product thinking we add to your
                                business — helping you grow from where you are to where you want to go next.
                            </p>
                            <p>
                                We are bootstrapped and proud of it. It keeps us close to our clients,
                                honest about scope and focused on solutions that pay for themselves.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ---------- Values ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <div className="wx-section-head wx-reveal">
                        <div className="wx-kicker">Values</div>
                        <h2 className="wx-h2">How we work.</h2>
                    </div>
                    <div className="wx-services-grid">
                        {values.map((v, i) => (
                            <div key={v.name} className="wx-service-card wx-reveal"
                                 style={{transitionDelay: `${i * 90}ms`}}>
                                <div className="wx-service-index">{String(i + 1).padStart(2, '0')} /</div>
                                <div className="wx-service-title">{v.name}</div>
                                <div className="wx-service-desc">{v.desc}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ---------- Team ---------- */}
            <section className="wx-section" id="team">
                <div className="wx-container">
                    <div className="wx-section-head is-center wx-reveal">
                        <div className="wx-kicker">Team</div>
                        <h2 className="wx-h2">The people behind WorkAxis.</h2>
                    </div>
                    <div className="wx-team-grid">
                        {ourTeam.map((member, i) => (
                            <a href={member.link} target="_blank" rel="noreferrer" key={member.name}
                               className="wx-team-card wx-reveal" style={{transitionDelay: `${i * 90}ms`}}>
                                <img src={member.image} loading="lazy" alt={member.name} className="wx-team-photo"/>
                                <div className="wx-team-name">{member.name}</div>
                                <div className="wx-team-role">{member.role}</div>
                            </a>
                        ))}
                    </div>
                </div>
            </section>

            {/* ---------- Testimonials ---------- */}
            <section className="wx-section wx-section-tight">
                <div className="wx-container">
                    <div className="wx-section-head is-center wx-reveal">
                        <div className="wx-kicker">Testimonials</div>
                        <h2 className="wx-h2">What partners say.</h2>
                    </div>
                </div>
                <div className="wx-marquee">
                    {[0, 1].map((dup) => (
                        <div className="wx-marquee-track" aria-hidden={dup === 1} key={dup}>
                            {testimony.map((t) => (
                                <div className="wx-quote-card" key={dup + t.name}>
                                    <div className="wx-quote-text">{t.command}</div>
                                    <div className="wx-quote-person">
                                        <div className="wx-quote-name">{t.name}</div>
                                        <div className="wx-quote-role">{t.designation}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </section>

            <CtaSection/>
        </div>
    );
}
